import styled, { css } from "styled-components";
import Colors from "constants/Colors";
import Icon from "components/Icon";
import {
  QuicksandBold,
  QuicksandRegular,
  QuicksandMedium,
} from "components/Text";
import { Row, Col } from "components/Grid";

export const LabelTitle = styled.p`
  ${QuicksandBold}
  font-size: 14px;
  line-height: 21px;
  text-transform: uppercase;
  color: #0f0c35;
  margin: 0px;
`;

export const LabelText = styled.p`
  ${QuicksandBold}
  font-size: 18px;
  line-height: 27px;
  color: #2c2a28;
  margin: 0px;
`;

export const RowStyled = styled(Row)`
  margin-bottom: 10px;
`;

export const ColStyled = styled(Col)`
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 12px;
  padding-bottom: 12px;
  ${({ isActive }) =>
    isActive ? "background-color: white;" : "background-color: #E5E5E5;"}
  cursor: pointer;
`;

export const LabelTypePlan = styled.p`
  ${QuicksandBold}
  font-size: 16px;
  line-height: 24px;
  color: #2c2a28;
  margin: 0px;
`;

export const LabelInfoPlan = styled.p`
  ${QuicksandBold}
  margin: 0px;
  display: flex;
  align-items: center;

  font-size: ${({ fs }) => fs || "14"}px;
  ${({ nbb }) => (nbb ? "" : "border-bottom: 2px solid #C4C4C4;")}
  line-height: ${({ lh }) => lh || "21"}px;
  color: ${({ color }) => color || "#A3A3A3"};
  ${({ center }) =>
    center ? "justify-content: center; text-align: center;" : ""}

  ${({ pt }) => (pt ? `padding-top: ${pt}px;` : "")}
  ${({ pb }) => (pb ? `padding-bottom: ${pb}px;` : "")}
  ${({ pl }) => (pl ? `padding-left: ${pl}px;` : "")}
  ${({ pr }) => (pr ? `padding-right: ${pr}px;` : "")}
  ${({ mnh }) => (mnh ? `min-height: ${mnh}px;` : "")}
  ${({ mxh }) => (mxh ? `max-height: ${mxh}px;` : "")}
  ${({ flexEnd }) => (flexEnd ? "align-items: flex-end;" : "")}
  ${({ largeWidth }) =>
    largeWidth
      ? "@media screen and (min-width: 768px) { width: 110%; padding-right: 10%; }"
      : ""}
`;

export const ButtonContract = styled.div`
  padding-left: 16.5px;
  padding-right: 15.5px;
  padding-bottom: 14px;
  padding-top: 14px;
  background-color: ${Colors.SECONDARY};
  width: 131px;
  margin: auto;
  margin-top: 10px;
  margin-bottom: 32px;
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  cursor: pointer;
  border-bottom: 2px solid #c4c4c4;
`;

export const Notice = styled.div`
  min-height: 70vh;
  flex-direction: column;
  display: flex;
  align-items: center;
  justify-content:center;
  border-radius: 10px;
`;

export const DivIcon = styled.div`
  padding-top: 12px;
  padding-bottom: 13px;
  max-height: 61px;
  min-height: 60px;
  border-bottom: 2px solid #c4c4c4;
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ isFirst }) =>
    isFirst ? "border-top: 2px solid #C4C4C4; min-height: 62px;" : ""}
  ${({ isLast }) =>
    isLast
      ? "width: 100%;"
      : "@media screen and (min-width: 768px) { width: 110%; }"}
`;

export const IconErrorOrGreen = styled(Icon)`
  ${({ isLast }) => isLast ? '' : `
  @media screen and (min-width: 768px) {
    margin-left: -10%;
  }`}
`;
export const Heading = styled.h2`
  color: ${Colors.GRAY[6]};
  padding-left: 10px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;

  margin-top: 20px;
  width: 100%;
  padding: 0px 0px 0px 20px;
`;

export const BackToList = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;
